import React, { useState } from 'react';
import './Review.css';

const EMPRESAS = ['PP', 'BA', 'PA', 'MA'];
const TIPOS = ['Fatura', 'Recibo', 'Contrato', 'Guia de Transporte', 'Extrato Bancário', 'Documento'];

export default function Review({ scanData, onConfirm, onBack }) {
  const { dados = {}, confianca = 0, preview } = scanData || {};

  const [tipo, setTipo] = useState(dados.tipo || 'Fatura');
  const [entidade, setEntidade] = useState(dados.entidade || '');
  const [data, setData] = useState(dados.data || '');
  const [montante, setMontante] = useState(dados.montante || '');
  const [nif, setNif] = useState(dados.nif || '');
  const [empresa, setEmpresa] = useState('PP');

  const handleConfirm = () => {
    onConfirm({
      tipo, entidade, data, montante, nif, empresa,
      imagem: scanData.imagem,
      preview
    });
  };

  return (
    <div className="review-page">
      <div className="review-body">
        {preview && (
          <div className="review-thumb-wrap">
            <img src={preview} alt="Documento" className="review-thumb" />
          </div>
        )}

        <div className="confidence-bar">
          <div className="conf-dot" />
          <span>OCR com {confianca}% de confiança</span>
        </div>

        <div className="field-group">
          <label className="field-label">Tipo de documento</label>
          <select className="field-select" value={tipo} onChange={e => setTipo(e.target.value)}>
            {TIPOS.map(t => <option key={t}>{t}</option>)}
          </select>
        </div>

        <div className="field-group">
          <label className="field-label">Entidade (fornecedor / cliente)</label>
          <input
            className="field-input"
            value={entidade}
            onChange={e => setEntidade(e.target.value)}
            placeholder="Nome da empresa ou pessoa"
          />
        </div>

        <div className="fields-row">
          <div className="field-group">
            <label className="field-label">Data</label>
            <input
              className="field-input"
              value={data}
              onChange={e => setData(e.target.value)}
              placeholder="DD/MM/AAAA"
            />
          </div>
          <div className="field-group">
            <label className="field-label">Montante</label>
            <input
              className="field-input"
              value={montante}
              onChange={e => setMontante(e.target.value)}
              placeholder="€ 0,00"
            />
          </div>
        </div>

        <div className="field-group">
          <label className="field-label">NIF</label>
          <input
            className="field-input"
            value={nif}
            onChange={e => setNif(e.target.value)}
            placeholder="9 dígitos"
          />
        </div>

        <div className="field-group">
          <label className="field-label">Empresa do grupo</label>
          <div className="empresa-grid">
            {EMPRESAS.map(emp => (
              <button
                key={emp}
                className={`empresa-card ${empresa === emp ? 'selected' : ''} ${emp.toLowerCase()}`}
                onClick={() => setEmpresa(emp)}
              >
                {emp}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="review-footer">
        <button className="review-back-btn" onClick={onBack}>← Voltar</button>
        <button className="review-next-btn" onClick={handleConfirm}>
          Escolher destino →
        </button>
      </div>
    </div>
  );
}
